<template>
    <div id='embargo'  v-if="alertShow">
        <div class="box">
            <div class="content">
                <div class="p">{{p}}</div>
                <h2 class="h">{{title}}</h2>
                <div class="imgs">
                    <img src="./img/food.png" alt="禁運物品">
                    <img src="./img/lotion.png" alt="禁運物品">
                    <img src="./img/medicine.png" alt="禁運物品">
                </div>
                <p>{{text}}</p>
                <div class="btns">
                    <div class="on">
                        <optionsButton title="知道了" :callback="on"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import optionsButton from '@/components/optionButton'
export default {
    name:'Embargo',
    props:["title","text","callback","alertShow",'p'],
    components:{
        optionsButton
    },
    data(){
        return {
        }
    },
    methods: {
        // 监听用户点击是
        on(){
            if(typeof this.callback == 'function'){
                this.callback(true)
            }
        },
    },
}
</script>

<style lang="less">
    #embargo{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background-color: #656565;
        z-index: 9999;
        .box{
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            animation: show .5s;
            .content{
                width: 600px;
                height: 600px;
                border-radius: 20px;
                background-color: #fff;
                text-align: center;
                padding:0 80px ;
                .p{
                    margin-top:10%;
                    color: @colorMain;
                    font-size:23px;
                    margin-bottom:3%;
                }
                .h{
                    text-align:center;
                    color: @colorMain;
                    font-size:30px;
                }
                .imgs{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 50px;
                    img{
                        width: 119px;
                        height: 118px;
                    }
                }
                p{
                    font-size: 17px;
                    font-weight: 580;
                    text-align:center;
                    margin-top: 100px;
                    margin-bottom: 50px;
                    line-height: 30px;
                    font-weight: 600;
                }
                .btns{
                    text-align: center;
                }
            }
        }
    }
</style>